// AI-CONTEXT: See docs/features/updates-log.md
// Hoeveel updates heeft deze gebruiker nog niet gezien? Voedt de badge op het
// menu-item 'Updates'.
//
// Afgeleid, niet opgeslagen: de gebruiker draagt één datum (`UpdatesSeenAt`,
// 'yyyy-mm-dd'), en alles wat nieuwer is en bij de modules van de organisatie
// hoort telt mee. Geen Notifications-documenten per organisatie per update, en
// een collega die de pagina opent maakt jóuw badge niet leeg.
//
// Die datum is de datum van de nieuwste update die de gebruiker zag, niet de
// dag van vandaag: een update krijgt zijn datum bij het bouwen en gaat pas
// dagen later live. Met 'vandaag' als grens zou hij nooit meetellen.
import filterUpdates from './filterUpdates'

/**
 * @param {*} updates - De ruwe lijst uit updates.json
 * @param {Array<string>} activeModules - Modulecodes die de organisatie afneemt
 * @param {*} seenUntil - 'yyyy-mm-dd' tot waar de gebruiker gekeken heeft; alles anders telt als nooit
 * @returns {number}
 */
const countUnseenUpdates = (updates, activeModules, seenUntil) => {
    const grens = typeof seenUntil === 'string' ? seenUntil : ''
    return filterUpdates(updates, activeModules).filter((update) => update.date > grens).length
}

/**
 * De datum van de nieuwste zichtbare update — wat er in `UpdatesSeenAt` komt
 * zodra de gebruiker de pagina opent.
 *
 * @param {*} updates - De ruwe lijst uit updates.json
 * @param {Array<string>} activeModules - Modulecodes die de organisatie afneemt
 * @returns {string} 'yyyy-mm-dd', of '' zonder zichtbare updates
 */
export const newestVisibleUpdateDate = (updates, activeModules) => {
    const zichtbaar = filterUpdates(updates, activeModules)
    return zichtbaar.length > 0 ? zichtbaar[0].date : ''
}

export default countUnseenUpdates
